/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

export const availableTimeframe = {
    '10m': 'Last 10 minutes',
    '30m': 'Last 30 minutes',
    '1h': 'Last hour',
    '4h': 'Last 4 hours',
    'today': 'Today',
    'yesterday': 'Yesterday',
};

export const historicalAvailableTimeframe = Object.assign({},
    availableTimeframe,
    {
        '7d': 'Last 7 days',
        '30d': 'Last 30 days',
    });

export const defaultTimeframe = '30m';


export const availableTimeUnit = {
    '1d': 'Day',
    '1h': 'Hour',
    '1m': 'Minute'
};

export const defaultTimeUnit = '1d';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/common.ts